__turbopack_context__.v({
  "readOnlyFolderAlert": "Folder-module__6t8P0q__readOnlyFolderAlert",
  "trashRetentionAlert": "Folder-module__6t8P0q__trashRetentionAlert",
});
